const translations = {
    labeledRate: 'Labeled Rate',
    rate: 'Rate',
    remove: 'Remove'
};

export default translations;
